import React, { useState } from 'react';
import MainLayout from '../components/MainLayout/MainLayout';
import './pages.css';
import { toast } from 'react-toastify';
import { BASE_URL } from '../Config';

const TemplateRegister = () => {
  const [templateName, setTemplateName] = useState('');
  const [language, setLanguage] = useState('en_US');
  const [category, setCategory] = useState('MARKETING');
  const [text, setText] = useState('');
  const [file, setFile] = useState(null);
  const [base64Image, setBase64Image] = useState('');
  const [activeSection, setActiveSection] = useState('');
  const [loading, setLoading] = useState(false);
  const [response, setResponse] = useState(null);
  const [variableCount, setVariableCount] = useState(0);
  const [variables, setVariables] = useState([]);
  // const [showToast, setShowToast] = useState(null);

  const handleAddVariable = () => {
    const newVariableCount = variableCount + 1;
    setVariableCount(newVariableCount);
    setText((prevText) => `${prevText}{{${newVariableCount}}}`);
    setVariables((prev) => [...prev, { id: newVariableCount, value: '' }]);
  };

  const handleVariableChange = (id, value) => {
    setVariables((prev) =>
      prev.map((variable) => (variable.id === id ? { ...variable, value } : variable))
    );
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setFile(file);

    const reader = new FileReader();
    reader.onloadend = () => {
      setBase64Image(reader.result.split(',')[1]);
    };
    reader.readAsDataURL(file);
  };

  const handleCancel = () => {
    setTemplateName('');
    setText('');
    setVariables([]);
    setBase64Image('');
    setFile(null);
  };

  const handleTemplateRegister = async () => {
    setLoading(true);

    try {
      let endpoint = '';
      let payload = {};

      if (activeSection === 'createTemplate') {
        endpoint = `${BASE_URL}/api/template`;
        payload = {
          templateName,
          language,
          category,
          text,
          examples: variables.map((variable) => variable.value),
        };
      } else if (activeSection === 'createMediaTemplate') {
        if (!base64Image) {
          alert('Please upload an image for the media template.');
          setLoading(false);
          return;
        }
        endpoint = `${BASE_URL}/api/template/createMediaTemplate`;
        payload = {
          templateName,
          language,
          category,
          text,
          examples: variables.map((variable) => variable.value),
          media: base64Image,
        };
      }

      const response = await fetch(endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'wabaId': localStorage.getItem('WabaId'),
          'phoneNumberId': localStorage.getItem('ClientPhoneNumberId'),
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        throw new Error(`Error: ${response.statusText}`);
      }

      const data = await response.json();
      setResponse(data);
      if (data.success === 'REJECTED') {
        toast.error('Templete Rejected!!,"please try again" ');
      } else {
        toast.success(`${data.message}`);
      }
    } catch (error) {
      toast.error('Error at template creation!');
      console.error('Error creating template:', error);
      setResponse({ error: error.message });
    } finally {
      setLoading(false);
    }
  };

  return (
    <MainLayout>
      <div style={{ padding: '20px', marginTop: '32px' }}>
        <div className="body">
          <div style={{ display: 'flex', justifyContent: 'space-between', gap: '10px' }}>
            <button
              className={`submitButton ${activeSection === 'createTemplate' ? 'active' : ''}`}
              style={{ width: '50%' }}
              onClick={() => setActiveSection('createTemplate')}
            >
              Create Template
            </button>
            <button
              className={`submitButton ${activeSection === 'createMediaTemplate' ? 'active' : ''}`}
              style={{ width: '50%' }}
              onClick={() => setActiveSection('createMediaTemplate')}
            >
              Create Media Template
            </button>
          </div>

          {activeSection === 'createTemplate' && (
            <div className="body" style={{ marginTop: '-22px' }}>
              <div style={{ display: 'flex', gap: '35px', width: '100%' }}>
                <div style={{ width: '70%' }} className="formStyle">
                  <h2>Create Text Template</h2>
                  <label htmlFor="templateName">Template Name:</label>
                  <span style={{ display: 'flex', gap: '11px' }}>
                    <input
                      id="templateName"
                      type="text"
                      placeholder="Template Name"
                      value={templateName}
                      onChange={(e) => setTemplateName(e.target.value)}
                      className="formInput"
                      style={{ width: '80%', height: 'max-content' }}
                    />
                    <div style={{ marginBottom: '10px' }}>
                      <button onClick={handleAddVariable} className="submitButton">
                        Add Variable
                      </button>
                    </div>
                  </span>
                  <label htmlFor="bodyText">Template Body Text:</label>
                  <textarea
                    id="bodyText"
                    placeholder="Text"
                    value={text}
                    onChange={(e) => setText(e.target.value)}
                    className="formInput"
                  />

                  {variables.map((variable) => (
                    <div key={variable.id} style={{ marginBottom: '10px' }}>
                      <label>
                        Variable {`${variable.id}`}:
                        <input
                          type="text"
                          value={variable.value}
                          onChange={(e) => handleVariableChange(variable.id, e.target.value)}
                          className="formInput"
                        />
                      </label>
                    </div>
                  ))}
                  <button
                    className="submitButton"
                    style={{ width: '20%', marginTop: '10px', marginLeft: '30%' }}
                    onClick={handleTemplateRegister}
                  >
                    Submit
                  </button>
                  <button
                    className="submitButton"
                    style={{ width: '20%', marginLeft: '10px', backgroundColor: '#a34f27' }}
                    onClick={handleCancel}
                  >
                    Cancel
                  </button>
                </div>
                <div style={{ marginTop: '20px' }}>
                  <h2>Your template preview in chat</h2>
                  <div style={styles.chatContainer}>
                    <div style={styles.messageBubble}>
                      <p style={styles.messageText}>
                        {text.trim() === '' ? 'Your text will appear here' : text.replace(/{{(\d+)}}/g, (_, index) =>
                          variables.find((variable) => variable.id === Number(index))?.value ||
                          `{{${index}}}`
                        )}
                      </p>
                      <span style={{ ...styles.messageTime, bottom: '1px' }}>18:57</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {activeSection === 'createMediaTemplate' && (
            <div className="body" style={{ marginTop: '-22px' }}>
              <div style={{ display: 'flex', gap: '35px', width: '100%' }}>
                <div style={{ width: '70%' }} className="formStyle">
                  <h2>Create Media Template</h2>
                  <label htmlFor="templateName">Template Name:</label>
                  <span style={{ display: 'flex', gap: '11px' }}>
                    <input
                      id="templateName"
                      type="text"
                      placeholder="Template Name"
                      value={templateName}
                      onChange={(e) => setTemplateName(e.target.value)}
                      className="formInput"
                      style={{ width: '80%', height: 'max-content' }}
                    />
                    <div style={{ marginBottom: '10px' }}>
                      <button onClick={handleAddVariable} className="submitButton">
                        Add Variable
                      </button>
                    </div>
                  </span>
                  <label htmlFor="bodyText">Template Body Text:</label>
                  <textarea
                    id="bodyText"
                    placeholder="Text"
                    value={text}
                    onChange={(e) => setText(e.target.value)}
                    className="formInput"
                  />
                  {variables.map((variable) => (
                    <div key={variable.id} style={{ marginBottom: '10px' }}>
                      <label>
                        Variable {`${variable.id}`}:
                        <input
                          type="text"
                          value={variable.value}
                          onChange={(e) => handleVariableChange(variable.id, e.target.value)}
                          className="formInput"
                        />
                      </label>
                    </div>
                  ))}
                  {/* <label htmlFor="addImage">Add Image:</label> */}
                  <label htmlFor="addImage" style={{ cursor: 'pointer', color: '#007bff' }}>
                    Choose image for your template
                  </label>
                  <input
                    id="addImage"
                    type="file"
                    onChange={handleFileChange}
                    className="formInput"
                  // style={{ display: 'none' }} // Hides the default file input button
                  />
                  <button
                    className="submitButton"
                    style={{ width: '20%', marginTop: '10px', marginLeft: '30%' }}
                    onClick={handleTemplateRegister}
                  >
                    Submit
                  </button>
                  <button
                    className="submitButton"
                    style={{ width: '20%', marginLeft: '10px', backgroundColor: '#a34f27' }}
                    onClick={handleCancel}
                  >
                    Cancel
                  </button>
                </div>
                <div style={{ marginTop: '20px' }}>
                  <h2>Your template preview in chat</h2>
                  <div style={styles.chatContainer}>
                    <div style={styles.messageBubble}>
                      {base64Image && (
                        <img
                          src={`data:image/png;base64,${base64Image}`}
                          alt="Media Preview"
                          style={styles.messageImage}
                        />
                      )}
                      <p style={styles.messageText}>
                        {text.trim() === '' ? 'Your text will appear here' : text.replace(/{{(\d+)}}/g, (_, index) =>
                          variables.find((variable) => variable.id === Number(index))?.value ||
                          `{{${index}}}`
                        )}
                      </p>
                      <span style={styles.messageTime}>18:57</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

        </div>
        <div>
          <h3>Template Rules</h3>
          <ul >
            <li style={{ backgroundColor: 'white' }}>The name must be 512 characters or less and can only contain lowercase letters, numbers, and underscores.</li>
            <li style={{ backgroundColor: 'white' }}>You can't use the same name for more than one template.</li>
            <li style={{ backgroundColor: 'white' }}>Edit available only for Approved, Rejected, or Paused templates</li>
            <li style={{ backgroundColor: 'white' }}>Templates can be edited up to 10 times per month</li>
            <li style={{ backgroundColor: 'white' }}>Maximum variables: 10</li>
          </ul>
        </div>
      </div>
    </MainLayout>
  );
};

const styles = {
  chatContainer: {
    display: 'flex',
    justifyContent: 'flex-start',
    padding: '10px',
    backgroundColor: '#eae6df',
    borderRadius: '10px',
    width: '100%',
    maxWidth: '400px',
    margin: '20px auto',
  },
  messageBubble: {
    backgroundColor: '#fff',
    borderRadius: '10px',
    padding: '10px',
    boxShadow: '0px 2px 3px rgba(0, 0, 0, 0.1)',
    maxWidth: '80%',
    position: 'relative',
  },
  messageImage: {
    width: '100%',
    borderRadius: '5px',
    marginBottom: '10px',
  },
  messageText: {
    margin: 0,
    fontSize: '14px',
    color: '#000',
  },
  messageTime: {
    position: 'absolute',
    bottom: '5px',
    right: '10px',
    fontSize: '12px',
    color: '#999',
  },
};


export default TemplateRegister;
